"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FabricDataMap_1 = require("./FabricDataMap");
var PdfExportUtil_1 = require("./PdfExportUtil");
var AcToast_1 = require("../notification/AcToast");
exports.usePdfEditor = function () {
    var pdfEditorCanvasMethodsRef = react_1.useRef();
    var pdfDoc = react_1.useRef();
    /**
     * Indicator whether a new PDF Document is being loaded.
     * A change of this status should reset the states of subscriber to handle a new document.
     */
    var _a = react_1.useState(true), loading = _a[0], setLoading = _a[1];
    /**
     * Indicator whether a new PDF Document Page is being loaded.
     * A change of this status should reset the states of subscriber to handle a new page.
     */
    var _b = react_1.useState(true), pageLoading = _b[0], setPageLoading = _b[1];
    /**
     * pageNumber starts with 1
     */
    var _c = react_1.useState(0), pageNumber = _c[0], setPageNumber = _c[1];
    var _d = react_1.useState(0), prevPageNumber = _d[0], setPrevPageNumber = _d[1];
    /**
     * Store pages which are active and not logically deleted.
     */
    var _e = react_1.useState([]), activePages = _e[0], setActivePages = _e[1];
    var _f = react_1.useState(0), rotationAngle = _f[0], setRotationAngle = _f[1];
    var _g = react_1.useState(0), prevRotationAngle = _g[0], setPrevRotationAngle = _g[1];
    /**
     * Rotation angles stored in the PDF Document.
     */
    var _h = react_1.useState([]), pageRotationAngles = _h[0], setPageRotationAngles = _h[1];
    var _j = react_1.useState([]), rotationAngles = _j[0], setRotationAngles = _j[1];
    var _k = react_1.useState(false), showEditor = _k[0], setShowEditor = _k[1];
    var eventListenerMap = react_1.useState(new Map())[0];
    var _l = react_1.useState(), pdfEditorViewDimension = _l[0], setPdfEditorViewDimension = _l[1];
    var _m = react_1.useState(), prevPdfEditorViewDimension = _m[0], setPrevPdfEditorViewDimension = _m[1];
    /**
     * pdf Scaling on preview & edit
     */
    var pdfScaleRange = [1, 1.1, 1.25, 1.5, 1.75, 2, 2.5];
    var _o = react_1.useState(0), pdfScaleIndex = _o[0], setPdfScaleIndex = _o[1];
    var _p = react_1.useState(pdfScaleRange[pdfScaleIndex]), pdfScale = _p[0], setPdfScale = _p[1];
    var fabricDataMap = react_1.useState(new FabricDataMap_1.FabricDataMap())[0];
    var updatePageNumber = function (_pageNumber) {
        setPageNumber(_pageNumber);
    };
    var isPdfFirstScale = pdfScaleIndex === 0;
    var isPdfLastScale = pdfScaleIndex === pdfScaleRange.length - 1;
    var pdfScaleReset = function () {
        // reset the scale back to 1.0
        setPdfScaleIndex(0);
        setPdfScale(pdfScaleRange[0]);
    };
    var pdfScaleUp = function () {
        if (!isPdfLastScale) {
            var newPdfScaleIndex = pdfScaleIndex + 1;
            setPdfScaleIndex(newPdfScaleIndex);
            setPdfScale(pdfScaleRange[newPdfScaleIndex]);
        }
    };
    var pdfScaleDown = function () {
        if (pdfScaleIndex > 0) {
            var newPdfScaleIndex = pdfScaleIndex - 1;
            setPdfScaleIndex(newPdfScaleIndex);
            setPdfScale(pdfScaleRange[newPdfScaleIndex]);
        }
    };
    var nextPage = function () {
        var existingPagesIndex = activePages.indexOf(pageNumber);
        if (existingPagesIndex < activePages.length - 1) {
            updatePageNumber(activePages[existingPagesIndex + 1]);
            pdfScaleReset();
        }
    };
    var prevPage = function () {
        var existingPagesIndex = activePages.indexOf(pageNumber);
        if (existingPagesIndex > 0) {
            updatePageNumber(activePages[existingPagesIndex - 1]);
            pdfScaleReset();
        }
    };
    var initActivePages = function (numPages) {
        if (fabricDataMap.existingPages.length === 0) {
            var _activePages = [];
            for (var i = 0; i < numPages; i++) {
                _activePages.push(i + 1);
            }
            setActivePages(_activePages);
            fabricDataMap.existingPages = _activePages;
            updatePageNumber(1);
        }
        else {
            setActivePages(fabricDataMap.existingPages);
            updatePageNumber(fabricDataMap.existingPages[0]);
        }
    };
    var deletePage = function (deletedPageNumber) {
        if (activePages.length === 1) {
            AcToast_1.notifyMessage('これ以上はページを削除できません。', 'ERROR');
            console.error('Cannot delete last page');
            return;
        }
        var newExistingPages = __spreadArrays(activePages);
        var existingPagesIndex = activePages.indexOf(deletedPageNumber);
        newExistingPages.splice(existingPagesIndex, 1);
        setActivePages(newExistingPages);
        fabricDataMap.existingPages = newExistingPages;
        if (existingPagesIndex < newExistingPages.length) {
            updatePageNumber(newExistingPages[existingPagesIndex]);
        }
        else {
            // if was on last page
            updatePageNumber(newExistingPages[existingPagesIndex - 1]);
        }
    };
    /**
     * Update the rotation angle for the current page for the first time
     * @param angle
     */
    var initPageRotationAngle = function (_pageNumber, angle) {
        if (activePages.length === 0)
            throw new Error('initPageRotationAngle: activePages are not initiated');
        if (_pageNumber !== pageNumber)
            throw new Error('initPageRotationAngle: supplied pageNumber differs from the current pageNumber');
        var pageIndex = pageNumber - 1;
        if (pageRotationAngles[pageIndex] === undefined) {
            pageRotationAngles[pageIndex] = angle;
            if (fabricDataMap.rotationArray[pageIndex] !== undefined) {
                rotationAngles[pageIndex] = fabricDataMap.rotationArray[pageIndex];
            }
            else {
                rotationAngles[pageIndex] = angle;
            }
        }
        setRotationAngle(rotationAngles[pageIndex]);
        setPrevRotationAngle(rotationAngles[pageIndex]);
    };
    /**
     * Update the rotation angle for the current page
     * @param angle
     */
    var updatePageRotationAngle = function (angle) {
        rotationAngles[pageNumber - 1] = angle;
        setRotationAngle(angle);
    };
    var rotateLeft = function () {
        var a = (rotationAngle - 90) % 360;
        if (a < 0)
            a = 360 + a; // Keep positive number
        updatePageRotationAngle(a);
    };
    var rotateRight = function () {
        updatePageRotationAngle((rotationAngle + 90) % 360);
    };
    var enableEditor = function (fabricDataMapJSON) {
        fabricDataMap.rotationArray = [];
        fabricDataMap.fabricData = [];
        if (fabricDataMapJSON) {
            fabricDataMap.initWithJSON(fabricDataMapJSON);
            setRotationAngles(fabricDataMap.rotationArray);
        }
        setShowEditor(true);
    };
    var disableEditor = function () {
        setShowEditor(false);
    };
    var on = function (pdfEditorEvent, handler) {
        if (handler === null || handler === undefined) {
            eventListenerMap.delete(pdfEditorEvent);
            return;
        }
        if (!eventListenerMap.has(pdfEditorEvent)) {
            eventListenerMap.set(pdfEditorEvent, []);
        }
        var handlers = eventListenerMap.get(pdfEditorEvent);
        if (handlers)
            handlers.push(handler);
    };
    var hasListener = function (pdfEditorEvent) {
        var handlers = eventListenerMap.get(pdfEditorEvent);
        return !!(handlers && handlers.length > 0);
    };
    var addPdfEditorObject = function (object) {
        if (pdfEditorCanvasMethodsRef && pdfEditorCanvasMethodsRef.current) {
            pdfEditorCanvasMethodsRef.current.addPdfEditorObject(object);
        }
        else {
            throw new Error('pdfEditorCanvasMethodsRef is not initialized');
        }
    };
    var getFabricDataMap = function () {
        if (pdfEditorCanvasMethodsRef && pdfEditorCanvasMethodsRef.current) {
            var map = pdfEditorCanvasMethodsRef.current.getFabricDataMap();
            map.rotationArray = rotationAngles;
            return map;
        }
        throw new Error('pdfEditorCanvasMethodsRef is not initialized');
    };
    var exportPdf = function (grayscale) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (pdfDoc.current) {
                return [2 /*return*/, PdfExportUtil_1.createPdf(pdfDoc.current, getFabricDataMap(), grayscale)];
            }
            return [2 /*return*/, undefined];
        });
    }); };
    var downloadPdf = function (filename) {
        if (pdfDoc.current)
            PdfExportUtil_1.downloadPdf(pdfDoc.current, getFabricDataMap(), filename);
    };
    var dispatch = function (pdfEditorEvent) { return __awaiter(void 0, void 0, void 0, function () {
        var handlers, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasListener(pdfEditorEvent)) return [3 /*break*/, 4];
                    handlers = eventListenerMap.get(pdfEditorEvent);
                    if (!handlers) return [3 /*break*/, 4];
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < handlers.length)) return [3 /*break*/, 4];
                    // eslint-disable-next-line no-await-in-loop
                    return [4 /*yield*/, handlers[i]({
                            pdfEditorCanvasMethodsRef: pdfEditorCanvasMethodsRef,
                            pdfDoc: pdfDoc,
                            loading: loading,
                            setLoading: setLoading,
                            pageLoading: pageLoading,
                            setPageLoading: setPageLoading,
                            pageNumber: pageNumber,
                            prevPageNumber: prevPageNumber,
                            setPrevPageNumber: setPrevPageNumber,
                            updatePageNumber: updatePageNumber,
                            nextPage: nextPage,
                            prevPage: prevPage,
                            activePages: activePages,
                            initActivePages: initActivePages,
                            deletePage: deletePage,
                            pageRotationAngles: pageRotationAngles,
                            rotationAngles: rotationAngles,
                            rotationAngle: rotationAngle,
                            prevRotationAngle: prevRotationAngle,
                            setPrevRotationAngle: setPrevRotationAngle,
                            initPageRotationAngle: initPageRotationAngle,
                            updatePageRotationAngle: updatePageRotationAngle,
                            rotateLeft: rotateLeft,
                            rotateRight: rotateRight,
                            fabricDataMap: fabricDataMap,
                            enableEditor: enableEditor,
                            disableEditor: disableEditor,
                            showEditor: showEditor,
                            pdfEditorViewDimension: pdfEditorViewDimension,
                            setPdfEditorViewDimension: setPdfEditorViewDimension,
                            prevPdfEditorViewDimension: prevPdfEditorViewDimension,
                            setPrevPdfEditorViewDimension: setPrevPdfEditorViewDimension,
                            on: on,
                            hasListener: hasListener,
                            addPdfEditorObject: addPdfEditorObject,
                            getFabricDataMap: getFabricDataMap,
                            exportPdf: exportPdf,
                            downloadPdf: downloadPdf,
                            pdfScale: pdfScale,
                            pdfScaleUp: pdfScaleUp,
                            pdfScaleDown: pdfScaleDown,
                            pdfScaleReset: pdfScaleReset,
                            isPdfFirstScale: isPdfFirstScale,
                            isPdfLastScale: isPdfLastScale,
                        })];
                case 2:
                    // eslint-disable-next-line no-await-in-loop
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i += 1;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        pdfEditorCanvasMethodsRef: pdfEditorCanvasMethodsRef,
        pdfDoc: pdfDoc,
        loading: loading,
        setLoading: setLoading,
        pageLoading: pageLoading,
        setPageLoading: setPageLoading,
        pageNumber: pageNumber,
        prevPageNumber: prevPageNumber,
        setPrevPageNumber: setPrevPageNumber,
        updatePageNumber: updatePageNumber,
        nextPage: nextPage,
        prevPage: prevPage,
        activePages: activePages,
        initActivePages: initActivePages,
        deletePage: deletePage,
        pageRotationAngles: pageRotationAngles,
        rotationAngles: rotationAngles,
        rotationAngle: rotationAngle,
        prevRotationAngle: prevRotationAngle,
        setPrevRotationAngle: setPrevRotationAngle,
        initPageRotationAngle: initPageRotationAngle,
        updatePageRotationAngle: updatePageRotationAngle,
        rotateLeft: rotateLeft,
        rotateRight: rotateRight,
        fabricDataMap: fabricDataMap,
        enableEditor: enableEditor,
        disableEditor: disableEditor,
        showEditor: showEditor,
        pdfEditorViewDimension: pdfEditorViewDimension,
        setPdfEditorViewDimension: setPdfEditorViewDimension,
        prevPdfEditorViewDimension: prevPdfEditorViewDimension,
        setPrevPdfEditorViewDimension: setPrevPdfEditorViewDimension,
        on: on,
        hasListener: hasListener,
        dispatch: dispatch,
        addPdfEditorObject: addPdfEditorObject,
        getFabricDataMap: getFabricDataMap,
        exportPdf: exportPdf,
        downloadPdf: downloadPdf,
        pdfScale: pdfScale,
        pdfScaleUp: pdfScaleUp,
        pdfScaleDown: pdfScaleDown,
        pdfScaleReset: pdfScaleReset,
        isPdfFirstScale: isPdfFirstScale,
        isPdfLastScale: isPdfLastScale,
    };
};
//# sourceMappingURL=UsePdfEditor.js.map